import { PageId } from 'constants/pages'

export const enum PageIdIntl1T {
  START = PageId.START_INTL_1T,
  QUESTION_1 = PageId.QUESTION_1_INTL_1T,
  QUESTION_2 = PageId.QUESTION_2_INTL_1T,
  QUESTION_3 = PageId.QUESTION_3_INTL_1T,
  QUESTION_4 = PageId.QUESTION_4_INTL_1T,
  SPEED_FEEDBACK = PageId.SPEED_FEEDBACK_INTL_1T,
  QUESTION_5 = PageId.QUESTION_5_INTL_1T,
  QUESTION_6 = PageId.QUESTION_6_INTL_1T,
  QUESTION_7 = PageId.QUESTION_7_INTL_1T,
  QUESTION_8 = PageId.QUESTION_8_INTL_1T,
  QUESTION_9 = PageId.QUESTION_9_INTL_1T,
  QUESTION_10 = PageId.QUESTION_10_INTL_1T,
  QUESTION_11 = PageId.QUESTION_11_INTL_1T,
  QUESTION_12 = PageId.QUESTION_12_INTL_1T,
  SMARTNESS_FEEDBACK = PageId.SMARTNESS_FEEDBACK_INTL_1T,
  QUESTION_13 = PageId.QUESTION_13_INTL_1T,
  QUESTION_14 = PageId.QUESTION_14_INTL_1T,
  QUESTION_15 = PageId.QUESTION_15_INTL_1T,
  QUESTION_16 = PageId.QUESTION_16_INTL_1T,
  QUESTION_17 = PageId.QUESTION_17_INTL_1T,
  QUESTION_18 = PageId.QUESTION_18_INTL_1T,
  QUESTION_19 = PageId.QUESTION_19_INTL_1T,
  QUESTION_20 = PageId.QUESTION_20_INTL_1T,
  LOGICAL_SKILLS_FEEDBACK = PageId.LOGICAL_SKILLS_FEEDBACK_INTL_1T,
  QUESTION_21 = PageId.QUESTION_21_INTL_1T,
  QUESTION_22 = PageId.QUESTION_22_INTL_1T,
  QUESTION_23 = PageId.QUESTION_23_INTL_1T,
  QUESTION_24 = PageId.QUESTION_24_INTL_1T,
  QUESTION_25 = PageId.QUESTION_25_INTL_1T,
  AGE_QUESTION = PageId.AGE_QUESTION_INTL_1T,
  EDUCATION_QUESTION = PageId.EDUCATION_QUESTION_INTL_1T,
  DISCOVER_FEEDBACKS = PageId.DISCOVER_FEEDBACKS_INTL_1T,
  PREPARE_FLOW = PageId.PREPARE_FLOW_INTL_1T,
  EMAIL = PageId.EMAIL_INTL_1T,
  OFFER = PageId.OFFER_INTL_1T,
  PAYMENT = PageId.PAYMENT_INTL_1T,
  REGISTRATION = PageId.REGISTRATION_INTL_1T,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_1T,
  CERTIFICATE = PageId.CERTIFICATE_INTL_1T,
  REPORT = PageId.REPORT_INTL_1T,
}
